import { render, staticRenderFns } from "./ui-page.vue?vue&type=template&id=320f407b"
import script from "./ui-page.vue?vue&type=script&lang=js"
export * from "./ui-page.vue?vue&type=script&lang=js"
import style0 from "./ui-page.vue?vue&type=style&index=0&id=320f407b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports